import * as managers from 'app/mocks/data/park/managers/list'

export const emailSettings1 = {
    id: 1,
    email_use_ssl: false,
    email_use_tls: true,
    email_host: `${managers.manager1.name}.com`,
    email_port: 1,
    default_from_email: `manager@${managers.manager1.name}.com`,
    email_host_user: `user-${managers.manager1.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager1.name}</p>`,
    client: managers.manager1.id,
}

export const emailSettings2 = {
    id: 2,
    email_use_ssl: false,
    email_use_tls: true,
    email_host: `${managers.manager2.name}.com`,
    email_port: 2,
    default_from_email: `manager@${managers.manager2.name}.com`,
    email_host_user: `user-${managers.manager2.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager2.name}</p>`,
    client: managers.manager2.id,
}

export const emailSettings3 = {
    id: 3,
    email_use_ssl: true,
    email_use_tls: false,
    email_host: `${managers.manager3.name}.com`,
    email_port: 3,
    default_from_email: `manager@${managers.manager3.name}.com`,
    email_host_user: `user-${managers.manager3.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager3.name}</p>`,
    client: managers.manager3.id,
}

export const emailSettings4 = {
    id: 4,
    email_use_ssl: true,
    email_use_tls: false,
    email_host: `${managers.manager4.name}.com`,
    email_port: 4,
    default_from_email: `manager@${managers.manager4.name}.com`,
    email_host_user: `user-${managers.manager4.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager4.name}</p>`,
    client: managers.manager4.id,
}

export const emailSettings5 = {
    id: 5,
    email_use_ssl: false,
    email_use_tls: false,
    email_host: `${managers.manager5.name}.com`,
    email_port: 5,
    default_from_email: `manager@${managers.manager5.name}.com`,
    email_host_user: `user-${managers.manager5.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager5.name}</p>`,
    client: managers.manager5.id,
}

export const emailSettings6 = {
    id: 6,
    email_use_ssl: true,
    email_use_tls: false,
    email_host: `${managers.manager6.name}.com`,
    email_port: 6,
    default_from_email: `manager@${managers.manager6.name}.com`,
    email_host_user: `user-${managers.manager6.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager6.name}</p>`,
    client: managers.manager6.id,
}

export const emailSettings7 = {
    id: 7,
    email_use_ssl: false,
    email_use_tls: true,
    email_host: `${managers.manager7.name}.com`,
    email_port: 7,
    default_from_email: `manager@${managers.manager7.name}.com`,
    email_host_user: `user-${managers.manager7.name}`,
    email_host_password: '',
    signature: `<p> signature ${managers.manager7.name}</p>`,
    client: managers.manager7.id,
}
